// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// semantic-ui
import { Header, Image, Container } from 'semantic-ui-react'

// state
import { Observer } from 'mobx-react'
import { store } from 'services/state.js'

import moment from 'moment'

// Create the plugin that provides our layout component
export const SwaggerLayoutPlugin = () => ({ components: { InfoContainer: InfoReplacement } })

function InfoReplacement ({ specSelectors }) {
  const info = specSelectors.info()
  const apiTitle = info.get('title')

  const now = moment();
  const newUser = now.diff(store.lastUpdatedDate, 'minutes') < 5;

  return <Container fluid textAlign='left' className='fixfloat' style={{ padding: '40px 0px' }}>
    <div style={{ display: 'flex', 'alignItems': 'center' }}>
      <div style={{ flex: '0 0 auto', marginRight: '20px' }}>
        <Image size='small' src={store.api.logo} width={150} height={150} />
      </div>
      <div>
        <Header as='h1'>{apiTitle}</Header>
      </div>
    </div>
    {newUser && <div className="new-user-warning">
      WARNING: If you are a new user, it may take up to 2 minutes for your account to finish provisioning
      before you are able to execute API calls.
    </div>}
  </Container>
}

export default SwaggerLayoutPlugin
